import classNames from "classnames";
import _ from "lodash";
import { twMerge } from "tailwind-merge";
import {
  Dropdown,
  FieldList,
  FieldName,
  IBaseInputProps,
  isValidFieldType,
} from "./Inputs";
import { checkFieldName } from "../../../utils";
import { checkDropdown } from "./utils";

export const InputSelector = ({
  customModel,
  overrideName,
  overrideHint,
  overrideRequired,
  ...restProps
}: IBaseInputProps & {
  type: keyof typeof FieldList | string;
  customModel?: string;
  overrideName?: string;
  overrideHint?: string;
  overrideRequired?: boolean;
}): JSX.Element => {
  const { type, name, modelname } = restProps;

  const [displayName, hint, required, accept, hide] = checkFieldName(
    name,
    customModel || modelname
  );

  if (hide) return <></>;

  const isDropdown = checkDropdown(name, modelname);
  const SelectedField =
    isDropdown !== null
      ? Dropdown
      : isValidFieldType(type)
      ? FieldList[type]
      : null;

  const finalRequired =
    overrideRequired !== undefined ? overrideRequired : required;

  return (
    <div
      className={twMerge(
        classNames("mb-2 space-y-1", {
          "flex flex-row gap-3": type === "bool",
        })
      )}
    >
      <FieldName
        name={overrideName || displayName}
        hint={overrideHint || hint}
        required={finalRequired}
      />
      {SelectedField ? (
        <SelectedField
          {...restProps}
          options={isDropdown !== null ? isDropdown : undefined}
          required={finalRequired}
          accept={accept}
        />
      ) : (
        <div className="text-gray-500">Unknown field type</div>
      )}
    </div>
  );
};
